import "primevue/resources/themes/aura-dark-amber/theme.css"
import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import PrimeVue from "primevue/config"
import Ripple from 'primevue/ripple';
import ToastService from 'primevue/toastservice';
import ConfirmationService from "primevue/confirmationservice"

import App from './App.vue'
import router from './router'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(PrimeVue, { ripple: true })

app.use(ToastService);
app.use(ConfirmationService)
app.directive('ripple', Ripple);

app.mount('#app')
